import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { SOFT_SHADOW } from "../../core/theme";
import dearLogo from "../../assets/images/dear_logo.png";

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

// Shared shell for the passwordless auth screens: brand logo above a single, centred card.
// Keeps the three steps (email → email code → SMS code) visually consistent.
const AuthLayout = ({ title, subtitle, children }: AuthLayoutProps) => {
  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", py: 6 }}>
      <Stack alignItems="center" sx={{ width: "100%", maxWidth: 440, px: 2 }}>
        <Box component="img" src={dearLogo} alt="DEARhealth" sx={{ width: 190, mb: 4 }} />
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: SOFT_SHADOW,
          }}
        >
          <Typography variant="h5" sx={{ mb: subtitle ? 0.5 : 3 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {subtitle}
            </Typography>
          )}
          {children}
        </Paper>
      </Stack>
    </Box>
  );
};

export default AuthLayout;
